import { Accordion } from "flowbite-react"
  const AndroidFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is Android development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Android development is the process of building applications for devices operating on the Android operating system. A lot of Android developers across the world choose Kotlin programming language, the Android SDK, user-friendly interfaces using Material Design principles and components, and other tools to develop Android apps.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which tools and technologies do you use to create an Android app?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  For developing an Android app, we leverage Kotlin/Java, XML as a programming language, Android Studio, Android SDK, Android NDK as tools & IDE, and SQLite & Realm as databases. For cross-platform applications, we use Flutter and React Native.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How much does android app development cost?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                The cost of building an Android application is quite contextual between $15,000 to $250,000 or above. It completely relies on variables like the genre of the app, degree of complexity, the timeframe of the app development, the number of features to integrate into the application, and more.
                </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Why should you hire Android developers from us?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                Here is a quick overview of the skills you get when you hire our developers: <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Native app development through the Android SDK</li>
                      <li>Hands-on experience in integrating APIs such as REST and SOAP</li>
                      <li>Solid knowledge of UI/UX design fundamentals</li>
                      <li>Leverage project management systems such as Jira, ASANA, etc.</li>
                      <li>Use version control systems such as Git for collaborative programming</li>
                      <li>Possess expertise not only in native mobile app development, but also in cross-platform frameworks such as React Native, Flutter, and more</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the benefits of outsourcing Android app development to us?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                There are numerous benefits when you outsource android app development to us. Some of them are, <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Reasonable operational and development cost</li>
                      <li>Flexibility to work under a tight timeline</li>
                      <li>Access to a vast pool of skilled Android developers</li>
                      <li>Ingrained knowledge of various Android tools, technologies, and platforms</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3" className="accordion-title">Will you support me in uploading my Android app to the Google Play Store?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Of course, we take complete responsibility to publish your Android app on the Play Store. It is one of the parts of our comprehensive Android app development solution offering.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default AndroidFAQ
